export default __webpack_public_path__ + "static/media/callsBlack.fd220bd9.svg";